import { Form } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { FormContent } from "@/components/page-canvas";

import { Button } from "@/components/ui/button";
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { ImageInput } from "@/components/image-input";
import { Spinner } from "@/components/ui/spinner";
import { userAccountPath } from "@/routes";
import type { Account } from "@/types";

export function AccountForm({ account }: { account: Account }) {
  const { t } = useTranslation();

  return (
    <Form
      action={userAccountPath()}
      method="patch"
      options={{ preserveScroll: true }}
    >
      {({ errors, processing }) => (
        <FormContent>
          <FieldGroup>
            <Field>
              <FieldLabel htmlFor="account_name">
                {t("common.account")}
              </FieldLabel>
              <Input
                id="account_name"
                name="account[name]"
                defaultValue={account.name}
                required
              />
              <FieldError>{errors.name?.[0]}</FieldError>
            </Field>
            <Field>
              <FieldLabel htmlFor="account_logo">{t("fields.logo")}</FieldLabel>
              {account.logo_url && (
                <img
                  src={account.logo_url}
                  alt={account.name}
                  className="size-16 object-contain"
                />
              )}
              <ImageInput
                id="account_logo"
                name="account[logo]"
                accept="image/png,image/jpeg,image/gif,image/webp"
              />
              <FieldError>{errors.logo?.[0]}</FieldError>
            </Field>
            <Button type="submit" className="w-fit" disabled={processing}>
              {processing && <Spinner />}
              {t("common.save")}
            </Button>
          </FieldGroup>
        </FormContent>
      )}
    </Form>
  );
}
